import { render, staticRenderFns } from "./ConsignmentStatusSelector.vue?vue&type=template&id=82ebad3e&scoped=true"
import script from "./ConsignmentStatusSelector.vue?vue&type=script&lang=js"
export * from "./ConsignmentStatusSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ebad3e",
  null
  
)

export default component.exports